module.exports = __webpack_public_path__ + "img/18.54a5b793.svg";